// ProtectedRoute.tsx
import { useAuth } from 'app/auth';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  requiredPermissions: string[]; // Array of required permissions
  typeChecker?: 'role' | 'type';
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiredPermissions,
  typeChecker = 'type',
  children,
}) => {
  const { currentUser } = useAuth();

  // Check if the user has the required permissions
  const valueToCheck = typeChecker === 'type' ? currentUser?.type : currentUser?.role;

  const isAuthorized = requiredPermissions.includes(valueToCheck || '');

  // If user is not authorized, redirect or display a message
  if (!isAuthorized) {
    return <Navigate to='/notfound' replace />;
  }

  // Otherwise, render the children components (the protected page)
  return <>{children}</>;
};

export default ProtectedRoute;
